import React, {useState, useEffect,useContext} from 'react';
import { useTranslate } from 'react-redux-multilingual';
import { InputSearchSupplementList } from "@gull";
import axios from 'axios';
import swal from "sweetalert2";
import { IsAuthContext } from 'app/App';
import SupplementListItem from './SupplementListComp/SupplementListItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus,faTimes} from '@fortawesome/free-solid-svg-icons';

const useLoad = (props) => {
    const t = useTranslate();
    const [loading,setLoading]=useState(false)
    const [reload,setReload]=useState(Date.now())

    useEffect(function () {
        if (props.editArticleId) {
            (async function() {
                setLoading(true)
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/supplement_list/get_article_supplement_list/"+props.editArticleId
                ).then((response) => {
                    if(!response.data.valid){
                        let interms='';
                        var keys = Object.keys(response.data.errors);
                        for(var i = 0; i < keys.length; i++){
                            interms+=response.data.errors[keys[i]].join(',')+','
                        }
                        interms=interms.split(',')
                        let messageError='';
                        interms.forEach(interm=>messageError+=t(interm)+'. ')
                        messageError=messageError.replace('undefined','');
                        swal.fire(messageError, "", "error");
                    }
                    else{   
                        props.setDataNextList(response.data.data)
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    swal.fire(t('unknowError'), "", "error");
                })
                setLoading(false)
            })()
        }
    }, [props.editArticleId,reload])
    
    return [loading,setLoading,setReload]
}

const ModalSupplementList = (props) =>{
    const t = useTranslate(); //Traduction
    const { authParam } = useContext(IsAuthContext); //AuthParams

    const [loading,setLoading,setReload] = useLoad(props) //useLoad

    // Ajout supplement liste
    const [showAddSupplementList, setShowAddSupplementList] = useState(false)
    const [supplementListAdd, setSupplementListAdd] = useState(false)

    const resetList = () =>{
        props.setDataNextList([])
        props.setLastListClicked([])
        setReload(Date.now())
        props.setEditArticleId(props.articleId)
    }

    const getNextList = async (article) =>{
        // setLoading(true)
        // const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/supplement_list/get_article_supplement_list/"+article.id
        // ).then((response) => {
        //     if(!response.data.valid){
        //         let interms='';
        //         var keys = Object.keys(response.data.errors);
        //         for(var i = 0; i < keys.length; i++){
        //             interms+=response.data.errors[keys[i]].join(',')+','
        //         }
        //         interms=interms.split(',')
        //         let messageError='';
        //         interms.forEach(interm=>messageError+=t(interm)+'. ')
        //         messageError=messageError.replace('undefined','');
        //         swal.fire(messageError, "", "error");
        //     }
        //     else{   
        //         props.setDataNextList(response.data.data)
        //         props.setEditArticleId(response.data.data.id)
        //     }
        // }).catch((error) => {
        //     if(error=='end_session') return;
        //     swal.fire(t('unknowError'), "", "error");
        // })
        // setLoading(false)
        props.setEditArticleId(article.id)
    }

    const action = (article) =>{   
        getNextList(article)
        props.setLastListClicked([article,...props.lastListClicked])//on sauvegarde le dernier article pour lequel on a affiché la liste 
    }

    const getPreviousList = () =>{
        if (props.lastListClicked) {
            if(props.lastListClicked.length==1){
                //Si il y a eu que un seul filtrage, on efface tout pour revenir que les raccourcis de base
                resetList()
            }else{
                //Si il y a eu plus d'un filtrage, on revient sur le filtrage précédent
                //Comme le dernier filtre est à l'index 0, si on souhaite revenir sur le filtre précédent, il faut utiliser le filtre qui suit à l'index 1 
                getNextList(props.lastListClicked[1])
                let newArr = []
                props.lastListClicked.map((value,index)=>{
                    if(index!=0) newArr.push(value)
                })
                props.setLastListClicked(newArr)
                // setDisabled(true)
            }
        }
    }

    const addList = async (supplementListId) => {
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/supplement_list/associate_supplement_list/"+supplementListId+"/"+props.editArticleId
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                setReload(Date.now())
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setSupplementListAdd(false)
        setShowAddSupplementList(false)
    }

    // Supprimer une liste
    const handleRemoveList = async (supplementListId) => {
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/supplement_list/remove_supplement_list/"+supplementListId+"/"+props.editArticleId
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                setReload(Date.now())
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
    }

    useEffect(function () {
        if (supplementListAdd!=false) addList(supplementListAdd);
    }, [supplementListAdd])

    // Pour préparer les supplement d'un article à ajouter dans un ticket
    const constructItem = async () => {

    }

    return(<>
        {(Object.keys(props.lastListClicked).length>0) &&
            <div className="row align-items-center">
                <div className="col">
                    <button disabled={loading} className="btn btn-sm btn-warning mb-1" onClick={()=>resetList()}>Reset</button>&nbsp;&nbsp;
                    <button disabled={loading} className="btn btn-sm btn-dark mb-1" onClick={()=>getPreviousList()}>{t('btnBack')}</button>
                </div>
            </div>
        }
        {(props.from=='erp') && 
            <div className='row form-group'>
                <div className='col-auto'>
                    <label>
                        {t('newSupplementList')}:&nbsp;&nbsp;
                    </label>
                </div>
                {(showAddSupplementList==false) ?
                    <div className='col-auto'>
                        <button
                            disabled={loading}
                            type="button"
                            className="btn btn-sm btn-success"
                            onClick={()=>setShowAddSupplementList(true)}
                        >
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                    </div>
                :
                    <>
                        <div className='col-auto'>
                            <InputSearchSupplementList
                                setSupplementListAdd={setSupplementListAdd}
                                datas={props.dataNextList}
                                disabled={loading}
                            />
                        </div>
                        <div className='col-auto'>
                            <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={()=>setShowAddSupplementList(false)}
                                disabled={loading}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                    </>
                }
            </div>
        }
        {(loading) ?
            <div className="text-center"><div className="spinner-border spinner-border-sm"></div></div>
        :
            <>
                {(Object.keys(props.dataNextList).length!=0) ?
                    <>
                        {props.dataNextList.supplement_list.map((value,key) => (
                            <SupplementListItem
                                key={value.id}
                                supplementList={value}
                                action={action}
                                handleRemoveList={handleRemoveList}
                                from={props.from}
                            />
                        ))}
                    </>
                :
                    false
                }
            </>
        }
    </>)
}

export default ModalSupplementList;